<template>
  <div>
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="类别名称" style="width:500px;">
        <el-input v-model="form.title" clearable placeholder="类别名称"></el-input>
      </el-form-item>
      <el-form-item label="关键字" style="width:500px;">
        <el-input v-model="form.keyword" clearable placeholder="关键字"></el-input>
      </el-form-item>
      <el-form-item label="描述" style="width:500px;">
        <el-input v-model="form.description" clearable placeholder="描述"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "art_type_form",
  data() {
    return {
      form: {
        title: "",
        keyword: "",
        description: ""
      }
    };
  }
};
</script>

<style scoped>
</style>